class EnvHelper {
  get extensionPrefix() {
    return 'byg_ppt'
  }

  get isProd() {
    return process.env.NODE_ENV === 'production'
  }

  get productName() {
    return 'byg_ppt'
  }

  get host() {
    return process.env.REACT_APP_HOST
  }

  get webHost() {
    return process.env.REACT_APP_WEB_HOST
  }

  get apiHost() {
    return this.webHost
  }

  get pptHost() {
    return process.env.REACT_APP_PPT_WEB_HOST
  }

  get apiBasePath() {
    return '/byy/internal_workbench'
  }
}

export const envHelper = new EnvHelper()
